<template>
    <group-backend-layout :page-title="classroom.name">
        <template #page_header>
            <div class="mb-8 flex w-full justify-between">
                <GroupClassroomName :classroom="classroom" />
                <div class="">
                    <GroupClassroomAddStudentModal :classroom="classroom" />
                </div>
            </div>
        </template>

        <GroupClassroomInstructor :classroom="classroom" />

        <div class="mt-2">
            <GroupClassroomManageGoalsTable :classroom="classroom" />

            <div class="mt-2">
                <group-classroom-students-overview
                    :classroom="classroom"
                ></group-classroom-students-overview>
            </div>
        </div>
    </group-backend-layout>
</template>

<script>
import GroupBackendLayout from "@/_Layouts/GroupBackendLayout";
import GroupClassroomStudentsOverview from "@/Components/GroupClassroomStudentsOverview";
import GroupClassroomAddStudentModal from "@/Components/GroupClassroomAddStudentModal";
import GroupClassroomInstructor from "@/Components/GroupClassroomInstructor";
import GroupClassroomManageGoalsTable from "@/Components/GroupClassroomManageGoalsTable";
import GroupClassroomName from "@/Pages/GroupBackend/GroupClassroomName.vue";

export default {
    name: "GroupClassroomShow",
    components: {
        GroupClassroomName,
        GroupClassroomManageGoalsTable,
        GroupClassroomInstructor,
        GroupClassroomAddStudentModal,
        GroupClassroomStudentsOverview,
        GroupBackendLayout,
    },
    props: {
        classroom: {
            type: Object,
            default: {},
        },
        students: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {};
    },
};
</script>
